module.exports = __webpack_public_path__ + "img/v4_followFundDetail_h.7ef1f9eb.png";